<template>
  <div>
    <!-- <list-add-new
      :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive"
      :kategoriJenisTiketOptions="kategoriJenisTiketOptions.options"
      @refetch-data="refetchData"
      @emitAddSuccess="emitAddSuccess"
    /> -->
    <!-- <b-button
      variant="primary"
      v-if="$can('create', 'tiket')"
      @click="tambah"
      class="mr-1"
    >
      <span class="text-nowrap">Tambah Tiket</span>
    </b-button> -->

    <!-- Table Container Card -->
    <list-filter
      :kanwil-filter.sync="kanwilFilter"
      :upt-filter.sync="uptFilter"
      :kategori-filter.sync="kategoriFilter"
      :jenis-filter.sync="jenisFilter"
      :status-filter.sync="statusFilter"
      :kanwilOptions="kanwilOptions.options"
      :kategoriJenisTiketOptions="kategoriJenisTiketOptions.options"
      :jenisTiketOptions="jenisTiketOptions.options"
      :statusTiketOptions="statusTiketOptions.options"
      :uptOptions="uptOptions.options"
      @emitReceiverUPT="reloadUPTOptions"
      @emitReceiverKategori="reloadKategoriOptions"
    />
    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button variant="primary" @click="tambah" v-if="$can('create', 'tiket')">
                <span class="text-nowrap">Tambah Konsultasi</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="fetchDatas"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: User -->
        <template #cell(jenis_keterampilan)="data">
          <b-media vertical-align="center">
            {{ data.item.jenis_keterampilan }}
            <small class="text-muted">{{ data.item.alamat }}</small>
          </b-media>
        </template>

        <template #cell(status_keterampilan)="data">
          <b-media vertical-align="center">
            {{ data.item.status_keterampilan }}
            <small class="text-muted">{{ data.item.alamat }}</small>
          </b-media>
        </template>

        <!-- <template #cell(jawaban_faq)="data">
          <b-media vertical-align="center">
              {{ data.item.jawaban_faq }}
            <small class="text-muted">{{ data.item.alamat }}</small>
          </b-media>
        </template> -->

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-button
            class="mr-1 btn-icon btn btn-relief-primary"
            variant="primary"
            v-if="
              $can('proses', 'tiket') &&
                canUpdate(data.item) &&
                data.item.is_draft === 0 &&
                canProses(userData, data.item)
            "
            :adminProcess="true"
            :to="{ name: 'pages-tiket-ubah', params: { id: data.item.id } }"
            title="Proses Data"
            alt="Proses Data"
          >
            <feather-icon icon="CheckCircleIcon" />
          </b-button>
          <b-button
            class="mr-1 btn-icon btn btn-relief-primary"
            variant="primary"
            v-else-if="
              ($can('proses', 'tiket') || !$can('proses', 'tiket')) &&
                data.item.is_draft === 0 &&
                data.item.status_tiket_id === 'e2281ff8-2558-11ee-acb1-3497f616fe22' &&
                canEdit(userData, data.item)
            "
            :to="{ name: 'pages-tiket-ubah', params: { id: data.item.id } }"
            title="Ubah Data"
            alt="Ubah Data"
          >
            <feather-icon icon="EditIcon" />
          </b-button>
          <b-button
            class="mr-1 btn-icon btn btn-relief-primary"
            variant="primary"
            v-if="
              $can('assign', 'tiket') &&
                data.item.user_tiket_all.length >= 2 &&
                canStatusApproval(data.item.user_tiket, data.item)
            "
            @click="approve(data.item.user_tiket[0].id)"
            title="Approve Data"
            alt="Approve Data"
          >
            <feather-icon icon="UserCheckIcon" />
          </b-button>
          <b-button
            class="mr-1 btn-icon btn btn-relief-primary mt-1"
            variant="primary"
            v-if="
              $can('assign', 'tiket') &&
                data.item.user_tiket_all.length >= 2 &&
                canStatusApproval(data.item.user_tiket, data.item)
            "
            @click="tolak(data.item.user_tiket[0].id)"
            title="Tolak Data"
            alt="Tolak Data"
          >
            <feather-icon icon="UserXIcon" />
          </b-button>
          <b-button
            class="mr-1 btn-icon btn btn-relief-primary mt-1"
            variant="primary"
            v-if="canAdmin(userData, data.item)"
            :to="{ name: 'pages-tiket-lihat', params: { id: data.item.id } }"
            title="Lihat Data"
            alt="Lihat Data"
          >
            <feather-icon icon="ZoomInIcon" />
          </b-button>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >Menampilkan {{ dataMeta.from }} per {{ dataMeta.to }} dari {{ dataMeta.of }} data
            </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import {
  getKategoriJenisTiket,
  deleteJenisTiket,
  getStatusTiketAll,
  getKanwil,
  getUPT,
  getJenisTiketByIdKateg,
} from '@/connection-api/master'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { avatarText } from '@core/utils/filter'
import storeModule from '@/connection-api/tiket-table/storeModule'
import useList from '@/connection-api/tiket-table/list'

import { approve, tolak } from '@/connection-api/tiket'
import ListFilter from './ListFilter.vue'
// import listAddNew from './ListAddNew.vue'
// import listFilters from './ListFilters.vue'

export default {
  components: {
    // listFilters,
    // listAddNew,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    // BLink,
    // BDropdown,
    // BDropdownItem,
    BPagination,
    ListFilter,
    vSelect,
  },
  data() {
    return {
      uptOptions: {
        selected: 'id',
        options: [{ value: null, label: '--Pilih UPT --' }],
      },
      kanwilOptions: {
        selected: 'id',
        options: [{ value: null, label: '--Pilih Jenis Kanwil --' }],
      },
      kategoriJenisTiketOptions: {
        selected: 'id',
        options: [{ value: null, label: '--Pilih Kategori Konsultasi --' }],
      },
      jenisTiketOptions: {
        selected: 'id',
        options: [{ value: null, label: '--Pilih Jenis Konsultasi --' }],
      },
      statusTiketOptions: {
        selected: 'id',
        options: [{ value: null, label: 'Semua' }],
      },
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  async mounted() {
    const responseKanwil = await getKanwil()
    // console.log(responseKanwil)
    this.mappingSelectOptionKanwil(responseKanwil.data, this.kanwilOptions.options)

    const response = await getKategoriJenisTiket()
    this.mappingSelectOption(response.data, this.kategoriJenisTiketOptions.options)

    const responseStatusTiket = await getStatusTiketAll()
    this.mappingSelectOption(responseStatusTiket.data, this.statusTiketOptions.options)
  },
  methods: {
    async reloadUPTOptions(kanwilId) {
      this.uptFilter = null
      this.uptOptions = {
        selected: 'id',
        options: [{ value: null, label: '--Pilih UPT --' }],
      }
      const responseUptOptions = await getUPT(kanwilId)
      this.mappingSelectOption(responseUptOptions.data, this.uptOptions.options)
    },
    async reloadKategoriOptions(kategoriId) {
      this.jenisFilter = null
      this.kategoriFilter = null
      this.jenisTiketOptions = {
        selected: 'id',
        options: [{ value: null, label: '--Pilih Jenis --' }],
      }
      const responseJenisOptions = await getJenisTiketByIdKateg(kategoriId)
      this.mappingSelectOption(responseJenisOptions.data, this.jenisTiketOptions.options)
    },
    mappingSelectOption(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.id,
          })
        })
      }
    },
    mappingSelectOptionKanwil(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.id,
          })
        })
      }
    },
    tambah() {
      // if (this.isValidTime() && this.isWeekday()) {
      //   this.$router.push('/tiket/tambah')
      // } else {
      //   this.notifyInvalidTime()
      // }
      this.$router.push('/tiket/tambah')
    },

    isValidTime() {
      const now = new Date()
      const currentHour = now.getHours()

      const utcHour = now.getUTCHours()
      const wibHour = (utcHour + 7) % 24
      return currentHour >= 8 && wibHour < 14
    },
    isWeekday() {
      const now = new Date()
      const day = now.getDay()
      // 0: Sunday, 1: Monday, ..., 6: Saturday
      return day >= 1 && day <= 5
    },
    notifyInvalidTime() {
      const now = new Date()
      const day = now.getDay()
      const currentHour = now.getHours()

      const utcHour = now.getUTCHours()
      const wibHour = (utcHour + 7) % 24

      if (day < 1 || day > 5) {
        // this.$notify({
        //   group: 'foo',
        //   title: 'Invalid Day',
        //   text: 'Input hanya diizinkan pada hari kerja (Senin - Jumat).'
        // });
        this.makeToast(
          'danger',
          'Mohon maaf pendaftaran konsultasi hanya diizinkan pada hari kerja (Senin - Jumat).',
        )
      } else if (wibHour < 8 || wibHour >= 14) {
        // this.$notify({
        //   group: 'foo',
        //   title: 'Invalid Time',
        //   text: 'Input hanya diizinkan dari pukul 08:00 sampai 15:00.'
        // });
        this.makeToast(
          'danger',
          'Mohon maaf pendaftaran konsultasi hanya diizinkan dari pukul 08:00 sampai 14:00 WIB.',
        )
      }
    },
    async approve(id) {
      try {
        const response = await approve(id)
        this.makeToast('success', 'Konsultasi Berhasil Di Approve!')
        window.location.reload()
      } catch (error) {
        this.makeToast('danger', error.response.data.data)
        this.show = false
      }
    },
    async tolak(id) {
      try {
        const response = await tolak(id)
        this.makeToast('success', 'Konsultasi Berhasil Di Tolak!')
        window.location.reload()
      } catch (error) {
        this.makeToast('danger', error.response.data.data)
        this.show = false
      }
    },
    makeToast(variant = null, message = null) {
      this.$bvToast.toast(message, {
        title: 'Konsultasi',
        variant,
        solid: true,
        autoHideDelay: 10000,
        enableHtml: true,
        allowHtml: true,
      })
    },
    emitAddSuccess(jenisTiketId) {
      this.$router.replace(`/kelola-jenistiket/edit/${jenisTiketId}`).then(() => {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Jenis Konsultasi',
            icon: 'CoffeeIcon',
            variant: 'success',
            text: 'Data berhasil di tambahkan',
          },
        })
      })
    },
    isExist(data) {
      if (this.onlyView === true) {
        return false
      }
      if (
        // eslint-disable-next-line operator-linebreak
        data.user_tiket_all.length > 0 &&
        // eslint-disable-next-line operator-linebreak
        data.user_tiket &&
        // eslint-disable-next-line operator-linebreak
        data.user_tiket[0] &&
        data.user_tiket[0].status_approval_id === '24a99fbd-2545-11ee-acb1-3497f616fa2'
      ) {
        return true
      }
      return false
    },
    canUpdate(data) {
      if (this.$can('manage', 'all')) {
        return true
      }
      if (data.is_draft === 0 && this.$can('update', 'tiket')) {
        return true
      }
      if (data.is_draft === 0 && this.$can('proses', 'tiket')) {
        return true
      }
      if (data.user_tiket_all.length > 0 && this.$can('update', 'tiket')) {
        return false
      }
      if (data.user_id === this.userData.id && this.$can('update', 'tiket')) {
        return true
      }
      if (data.user_tiket_all.length === 0 && this.$can('update', 'tiket')) {
        return true
      }
      if (
        // eslint-disable-next-line operator-linebreak
        data.user_tiket &&
        // eslint-disable-next-line operator-linebreak
        data.user_tiket[0] &&
        // eslint-disable-next-line operator-linebreak
        this.$can('update', 'tiket') &&
        data.user_tiket[0].status_approval_id === '24a99fbd-2545-11ee-acb1-3497f616fa2'
      ) {
        return true
      }
      return false
    },
    canEdit(dataUser, data) {
      if (data.user_id === dataUser.id) {
        return true
      }
      return false
    },
    canProses(dataUser, data) {
      const findUser = this.findUser(data.user_tiket_all, dataUser.id)
      // alert('a')
      // console.log(data)
      // console.log(dataUser.id)
      // console.log(data.user_id)
      // console.log(data.user_tiket_all)
      // console.log(findUser)
      if (dataUser.roles.indexOf('ditjenpas') !== -1 && dataUser.id !== data.user_id) {
        let returnData = true
        if (dataUser.roles.indexOf('superadmin') !== -1 || dataUser.roles.indexOf('admin') !== -1) {
          returnData = false
        } else if (dataUser.roles.indexOf('supervisor') !== -1) {
          if (data.status_tiket_id === 'e2281ff8-2558-11ee-acb1-3497f616fe6') {
            returnData = false
          }
        }
        return returnData
      }
      if (
        // eslint-disable-next-line operator-linebreak
        dataUser.roles.indexOf('ditjenpas') !== -1 &&
        // eslint-disable-next-line operator-linebreak
        findUser &&
        // eslint-disable-next-line operator-linebreak
        data.user_tiket_all.length >= 3
      ) {
        let returnData = true
        if (dataUser.roles.indexOf('superadmin') !== -1 || dataUser.roles.indexOf('admin') !== -1) {
          returnData = false
        } else if (dataUser.roles.indexOf('supervisor') !== -1) {
          if (data.status_tiket_id === 'e2281ff8-2558-11ee-acb1-3497f616fe6') {
            returnData = false
          }
        }
        return returnData
        // } if (dataUser.roles.indexOf('helpdesk') !== -1 && dataUser.id !== data.user_id && data.user_tiket_all.length <= data.user_tiket_all.length) {
        //   return true
      }
      if (dataUser.roles.indexOf('helpdesk') !== -1 && dataUser.id !== data.user_id) {
        let returnData = true
        if (dataUser.roles.indexOf('superadmin') !== -1 || dataUser.roles.indexOf('admin') !== -1) {
          returnData = false
        } else if (dataUser.roles.indexOf('supervisor') !== -1) {
          if (data.status_tiket_id === 'e2281ff8-2558-11ee-acb1-3497f616fe6') {
            returnData = false
          }
        }
        return returnData
      }
      if (
        // eslint-disable-next-line operator-linebreak
        dataUser.roles.indexOf('helpdesk') !== -1 &&
        // eslint-disable-next-line operator-linebreak
        findUser &&
        data.user_tiket_all.length >= 3
      ) {
        let returnData = true
        if (dataUser.roles.indexOf('superadmin') !== -1 || dataUser.roles.indexOf('admin') !== -1) {
          returnData = false
        } else if (dataUser.roles.indexOf('supervisor') !== -1) {
          if (data.status_tiket_id === 'e2281ff8-2558-11ee-acb1-3497f616fe6') {
            returnData = false
          }
        }
        return returnData
      }
      // else if(dataUser.roles.indexOf("supervisor") !== -1 && dataUser.id !== data.user_id && this.dataMeetup.user_tiket_all.length < 1)
      // {
      //   return true
      // }
      return false
    },
    canAdmin(dataUser, data) {
      // console.log(dataUser.id)
      let returnData = false
      if (dataUser.roles.indexOf('superadmin') !== -1 || dataUser.roles.indexOf('admin') !== -1) {
        returnData = true
      }
      if (dataUser.id === data.user_id) {
        returnData = true
      }
      return returnData
    },
    findUser(datas, userId) {
      let returnFindUser = false
      let totalApproval = 0
      let countData = datas.length
      const coba = datas.forEach(data => {
        if (data.status_approval_id !== '24a99fbd-2545-11ee-acb1-3497f616fa5') {
          totalApproval += 1
        }
        countData -= 1
        if (
          // eslint-disable-next-line operator-linebreak
          data.user_id === userId &&
          // eslint-disable-next-line operator-linebreak
          data.jenis_user_id !== null &&
          data.status_approval_id === '24a99fbd-2545-11ee-acb1-3497f616fa4'
        ) {
          returnFindUser = true
        }
        if (
          // eslint-disable-next-line operator-linebreak
          data.user_id === userId &&
          // eslint-disable-next-line operator-linebreak
          data.jenis_user_id === null &&
          // eslint-disable-next-line operator-linebreak
          data.status_approval_id === '24a99fbd-2545-11ee-acb1-3497f616fa2' &&
          totalApproval === 1
        ) {
          returnFindUser = true
        }
      })
      return returnFindUser
    },
    canStatusApproval(data, datas) {
      // if (data.length > 0 && data[0].status_approval_id === '24a99fbd-2545-11ee-acb1-3497f616fa2' && this.userData.roles.indexOf('supervisor') !== -1 && this.userData.id === data[0].user_id
      //   && datas.user_tiket_all.length === 3) {
      //   return true
      // }
      // console.log(datas.jumlah_user_assign)
      if (
        // eslint-disable-next-line operator-linebreak
        data.length > 0 &&
        // eslint-disable-next-line operator-linebreak
        this.userData.roles.indexOf('supervisor') !== -1 &&
        // eslint-disable-next-line operator-linebreak
        this.userData.id === data[0].user_id &&
        datas.jumlah_user_assign === 2
      ) {
        return true
      }
      if (
        // eslint-disable-next-line operator-linebreak
        data.length > 0 &&
        // eslint-disable-next-line operator-linebreak
        data[0].status_approval_id === '24a99fbd-2545-11ee-acb1-3497f616fa4' &&
        // eslint-disable-next-line operator-linebreak
        this.userData.roles.indexOf('supervisor') !== -1 &&
        // eslint-disable-next-line operator-linebreak
        this.userData.id === data[0].user_id &&
        datas.user_tiket_all.length === 3
      ) {
        return true
      }
      // else if(data.length > 0 && data[0].status_approval_id === 2 && this.userData.roles.indexOf("supervisor") === -1 && this.userData.id === data[0].user_id
      // && this.dataMeetup.user_tiket_all.length == 2)
      // {
      //   return true
      // }
      return false
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'keterampilan'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) {
      store.registerModule(USER_APP_STORE_MODULE_NAME, storeModule)
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) {
        store.unregisterModule(USER_APP_STORE_MODULE_NAME)
      }
    })

    const isAddNewUserSidebarActive = ref(false)

    const {
      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      kanwilFilter,
      uptFilter,
      kategoriFilter,
      jenisFilter,
      statusFilter,

      // jenisUptFilter,
      // uptFilter,
      // jenisAssetFilter,
      // statusAssetFilter,
    } = useList()

    return {
      // Sidebar
      isAddNewUserSidebarActive,

      fetchDatas,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,
      kanwilFilter,
      uptFilter,
      kategoriFilter,
      jenisFilter,
      statusFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
